import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Pin({ idVariant = '', className }: Props) {
  return (
    <IconBase name="pin" w={24} className={className}>
      <circle cx="12" cy="9" r="2.5" stroke="currentColor"/>
      <path d="M18.5 9C18.5 11.8257 16.84 14.7128 15.1053 16.943C14.2462 18.0476 13.3859 18.9695 12.7402 19.6152C12.4386 19.9168 12.1845 20.1575 12 20.3278C11.8156 20.1575 11.5614 19.9168 11.2598 19.6152C10.6141 18.9695 9.75381 18.0476 8.89468 16.943C7.16002 14.7128 5.5 11.8257 5.5 9C5.5 5.41015 8.41015 2.5 12 2.5C15.5899 2.5 18.5 5.41015 18.5 9Z" stroke="currentColor"/>
    </IconBase>
  )
}

export default Pin
